export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'Home',
      INDICADOR: 'Indicador'
    }
  }
}
